<nav aria-label="breadcrumb">
  <ol class="breadcrumb" *ngIf='breadcrumbs.length; else dashboard'>
    <li class="breadcrumb-item">
      <a aria-label='dashboard' routerLinkActive='active' [routerLink]='["/dashboard"]'><span>Project</span></a>
    </li>
    <ng-template #breadcrumbLi>
      <li *ngFor="let breadcrumb of breadcrumbs.slice(0,breadcrumbs.length-1); let i = index" class="breadcrumb-item">
        {{breadcrumb.queryParams['filter']}}
        <a routerLinkActive='active' [routerLink]='["/home"]'
          *ngIf='breadcrumb.label === "Project"; else nonHomeLink'><span></span></a>
        <ng-template #nonHomeLink>
          <a [routerLink]="[breadcrumb.url]" [queryParams]="breadcrumb.queryParams" matTooltip="{{breadcrumb.label}}">
            {{ breadcrumb.label }} </a>
        </ng-template>
      </li>
      <li class="breadcrumb-item active" aria-current="page" matTooltip="{{breadcrumbs[breadcrumbs.length-1].label}}">{{
        breadcrumbs[breadcrumbs.length-1].label }}</li>
    </ng-template>

    <li *ngIf='(showSpinnerAction$ | async); else breadcrumbLi'>
      <span class="breadcrumb-item icon-spin3 animate-spin">Loading...</span>
    </li>
    <li class="breadcrumb-controls"><span class="icon-resize-full" (click)='goFullScreen()'></span></li>
  </ol>
  <ng-template #dashboard>
    <ol class="breadcrumb">
      <li class="breadcrumb-item active">
        <span class='icon-home'></span>
      </li>
      <li *ngIf='(showSpinnerAction$ | async)'><span class="breadcrumb-item icon-spin3 animate-spin"></span></li>
    </ol>
  </ng-template>
</nav>
